import { clinicInfo_LABELS } from "../../../../constants/labels/ClinicInfo";
import Info from "../../../shared/SVG/Info";
import { ReactComponent as Settings } from "../../../../assets/svg/Settings.svg";
import { ReactComponent as NoLogo } from "../../../../assets/svg/noLogo.svg";
import { ReactComponent as DeleteLogo } from "../../../../assets/svg/DeleteFile.svg";

import "./ClinicInfo.scss";
import { Button } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import {
  useLazyDeleteClinicLogoQuery,
  useLazyGetManageSubscriptionUrlQuery,
  useLazyUpdateClinicUserDetailsQuery,
} from "../../../../services/rtkQueryServices/clinicService";
import FileUpload from "../../../shared/Input/FileUpload";
import Modal from "../../../shared/Modal/Modal";
import Slider from "../../../shared/Widget/Slider/Slider";
import { BpSiteIdVerificationHandler } from "./BpSiteIdVerificationHandler";
import ConfirmationDialog from "../../../shared/ConfirmationDialog/ConfirmationDialog";
import { ValidatePairingCodeDialog } from "./ValidatePairingCodeDialog";
import { useAuth } from "../../../../context/AuthProvider";
import { Roles } from "../../../../constants/data/Roles";
import { type ClinicUserDetails } from "../../../../models/response/clinicUserDetails";
import { ReactComponent as InfoIcon } from "../../../../assets/svg/info_lg.svg";
import { ReactComponent as DoneIcon } from "../../../../assets/svg/Done.svg";
import { useLazyRevalidateBpSiteIdQuery } from "../../../../services/rtkQueryServices/authenticationService";
import { useParams } from "react-router-dom";
import { Utility } from "../../../../utils/Utility";
import { errorMessages } from "../../../../constants/errorMessages";
export function ClinicInfo(props: any) {
  const [updateClinicUserDetails] = useLazyUpdateClinicUserDetailsQuery();
  const [deleteClinicLogo] = useLazyDeleteClinicLogoQuery();
  const [manageSubscriptionUrl] = useLazyGetManageSubscriptionUrlQuery();
  const [revalidateBpSiteId] = useLazyRevalidateBpSiteIdQuery();
  const [isReverifySuccess, setIsReverifySuccess] = useState<boolean>(false);
  const [isReverifyFailed, setIsReverifyFailed] = useState<boolean>(false);
  const [isPairedSite, setIsPairedSite] = useState<boolean>(true);
  const [fileUploadErrors, setFileUploadErrors] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isCustomerDeleted, setIsCustomerDeleted] = useState<boolean>(false);
  const { applicationUserId } = useParams();
  const auth = useAuth();
  let role = auth?.authClaims?.role;

  let userId =
    role === Roles.clinicAdmin
      ? auth?.authClaims?.applicationUserId
      : applicationUserId;

  const isBpSiteIdVerified = useMemo(() => {
    return props.isBpSiteIdVerified;
  }, [props.isBpSiteIdVerified]);
  const isSubscriptionActive = useMemo(() => {
    return props.isSubscriptionActive;
  }, [props.isSubscriptionActive]);
  const addressBookLastUpdateStatus = useMemo(() => {
    return props.addressBookLastUpdateStatus;
  }, [props.addressBookLastUpdateStatus]);
  const [openBpSiteIdHandler, setOpenBpSiteIdHandler] =
    useState<boolean>(false);

  useEffect(() => {
    if (props?.error) {
      setErrorMessage(props?.error);
    }
  }, [props.error]);
  const handleError = () => {
    setErrorMessage("");
  };

  useEffect(() => {
    if (errorMessage) {
      document.body.addEventListener("click", handleError);
    }
    return () => {
      document.body.removeEventListener("click", handleError);
    };
  }, [errorMessage]);
  const clinicUserData: ClinicUserDetails = useMemo(() => {
    return props?.clinicUserData;
  }, [props.clinicUserData]);
  const validateFileUpload = (file: any) => {
    let supportedTypes = process.env.REACT_APP_EVO_LOGO_SUPPORTED_TYPES?.split(
      ","
    ) || ["image/png", "image/jpg", "image/jpeg"];
    let error = null;
    if (file && supportedTypes.indexOf(file.type) < 0) {
      error = `Upload only JPEG/JPG/PNG files.`;
    } else if (file && file.size >= 30000) {
      error = "File size must be less than 30KB.";
    } else if (file && file.size <= 0) {
      error = "Empty files cannot be uploaded.";
    }
    return error;
  };
  const getAddressbookLastUpdateCss = (status?: string) => {
    switch (status?.toUpperCase()) {
      case "SUCCESS":
        return "addressbookupdateStatus-success";
      case "INPROGRESS":
        return "addressbookupdateStatus-inprogress";
      case "FAILURE":
      default:
        return "addressbookupdateStatus-failure";
    }
  };
  const getAddressbookLastUpdateTitle = (status?: string) => {
    switch (status?.trim()?.toUpperCase()) {
      case "SUCCESS":
        return "Active";
      case "INPROGRESS":
        return "Fetching Status";
      case "FAILURE":
      default:
        return "Inactive";
    }
  };
    const revalidateBpSite = async () => {
    revalidateBpSiteId({
      applicationUserId: userId,
      bpSiteId: props.clinicUserData?.bpSiteId,
    }).then((res: any) => {
      if (
        res.isSuccess &&
        res.data?.data?.isValidBpSiteId &&
        res.data?.data?.isSuccessfulSqlConnection
      ) {
        setIsReverifySuccess(true);
      } else if (!res.data.data?.isValidBpSiteId) {
        setIsPairedSite(false);
      }
      else if (
        res.isError ||
        !res.data.data?.isValidBpSiteId ||
        !res.data.data?.isSuccessfulSqlConnection
      ) {
        setIsReverifyFailed(true);
      }
    });
  };

  return (
    <>
      <div className="clinic-info-header d-flex align-items-center">
        <div className="error-message error flex-grow-1 text-align-center">
          {errorMessage}
        </div>
      </div>
      <div className="clinic-info-wrapper d-flex">
        <div className="clinic-logo-wrapper d-flex align-items-center">
          <div>
            {clinicUserData?.clinicLogoUrl ? (
              <img
                src={clinicUserData?.clinicLogoUrl}
                className="clinic-logo"
              ></img>
            ) : (
              <div className="no-clinic-logo d-flex flex-column justify-content-center align-items-center">
                <NoLogo />
                <div className="no-logo-info">No Logo Available</div>
              </div>
            )}
            <div className="logo-info pt-3">
              {fileUploadErrors ? (
                <div className="error-message">{fileUploadErrors}</div>
              ) : (
                auth?.authClaims?.role === Roles.clinicAdmin && (
                  <>*Upload your Clinic Logo</>
                )
              )}
            </div>
          </div>
          {
            <div className="d-flex flex-column align-items-center gap-1">
              <span className="help-icon ">
                <Info width={24} height={24} fillColor={"var(--label-color)"} />
                <div className="help-info">
                  {isBpSiteIdVerified && isSubscriptionActive ? (
                    <p>
                      Accepted file formats PNG, JPEG, JPG.
                      <br />
                      Max size - 30KB.
                    </p>
                  ) : !isSubscriptionActive ? (
                    <p>Renew your subscription to upload clinic logo</p>
                  ) : (
                    !isBpSiteIdVerified && (
                      <p>Verify your BP Site ID to upload clinic logo</p>
                    )
                  )}
                </div>
              </span>
              <Button disabled={!isBpSiteIdVerified || !isSubscriptionActive}>
                <FileUpload
                  name="Logo"
                  accept={process.env.REACT_APP_EVO_LOGO_SUPPORTED_TYPES}
                  fileUrl={""}
                  onClear={() => {}}
                  onInput={(e: any) => {
                    setFileUploadErrors("");
                    let image = (e.target as any).files[0];
                    let reader = new FileReader();
                    reader.onload = function () {
                      let base64String = (reader?.result as string)
                        .replace("data:", "")
                        ?.replace(/^.+,/, "");
                      const error = validateFileUpload(image);
                      setFileUploadErrors(error);
                      if (!error) {
                        updateClinicUserDetails({
                          clinicLogoUrl: image?.name,
                          clinicLogoFileData: base64String,
                          applicationUserId: userId,
                        }).then((res) => {
                          if (res.isSuccess) {
                            props.refetchClinicDetails();
                          } else {
                            setFileUploadErrors(
                              (res.error as any)?.data.message
                            );
                          }
                        });
                      }
                    };
                    reader.readAsDataURL(image);
                  }}
                  required
                  //infoIconProps={infoIconProps}
                  labelHelpText={
                    isBpSiteIdVerified && isSubscriptionActive ? (
                      <p>
                        Accepted file formats PNG, JPEG, JPG.
                        <br />
                        Max. size limit 30KB
                      </p>
                    ) : !isSubscriptionActive ? (
                      <p>Renew your subscription to upload clinic logo</p>
                    ) : (
                      !isBpSiteIdVerified && (
                        <p>Verify your BP Site ID to upload clinic logo</p>
                      )
                    )
                  }
                />
              </Button>
              {clinicUserData?.clinicLogoUrl &&
                isBpSiteIdVerified &&
                isSubscriptionActive && (
                  <>
                    <DeleteLogo
                      className="cursor-pointer"
                      onClick={() => {
                        setFileUploadErrors("");
                        deleteClinicLogo({ applicationUserId: userId }).then(
                          (res) => {
                            if (res.isSuccess) {
                              props.refetchClinicDetails();
                            }
                          }
                        );
                      }}
                    />
                  </>
                )}
            </div>
          }
        </div>
        {/* <div className="v-line"></div> */}
        <div className="clinic-details-wrapper d-flex flex-column flex-grow-1">
          <div className="clinic-details d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.clinicName}</div>
              <div className="clinic-info">{clinicUserData?.clinicName}</div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.user}</div>
              <div className="clinic-info">
                {clinicUserData?.firstName} {clinicUserData?.lastName}
              </div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.emailId}</div>
              <div className="clinic-info">{clinicUserData?.userEmail}</div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.bpSiteId}</div>
              {isBpSiteIdVerified ? (
                <div className="clinic-info">{clinicUserData?.bpSiteId}</div>
              ) : (
                isSubscriptionActive &&
                isBpSiteIdVerified !== null && (
                  <div>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setOpenBpSiteIdHandler(true);
                      }}
                    >
                      Verify BP Site ID
                    </Button>
                  </div>
                )
              )}
            </div>
          </div>
          <div className="clinic-details d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">{clinicInfo_LABELS.status}</div>
              <div className="clinic-info">
                {Utility.getSubscriptionType(
                  clinicUserData?.subscriptionPlan
                ) && (
                  <span>
                    {Utility.getSubscriptionType(
                      clinicUserData?.subscriptionPlan
                    )}{" "}
                    -{" "}
                  </span>
                )}
                <span
                  className={`clinic-info bold ${
                    isSubscriptionActive !== null &&
                    (isSubscriptionActive ? "Active" : "Inactive")
                  }`}
                >
                  {isSubscriptionActive !== null &&
                    (isSubscriptionActive ? "Active" : "Inactive")}
                </span>
              </div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">
                {clinicInfo_LABELS.totalLicenceKeys}
              </div>
              <div className="clinic-info">{clinicUserData?.licenseCount}</div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">
                {clinicInfo_LABELS.noOfUsersAdded}
              </div>
              <div className="clinic-info">{clinicUserData?.noOfUsers}</div>
            </div>
            <div className="d-flex flex-column flex-grow-1 clinic-details-group">
              <div className="clinic-label">
                {clinicInfo_LABELS.clinicAddress}
              </div>
              <div className="clinic-info">{clinicUserData?.clinicAddress}</div>
            </div>
          </div>
        </div>
        {(auth?.authClaims?.role === Roles.clinicAdmin ||
          (isBpSiteIdVerified && isSubscriptionActive)) && (
          <div className="manage-options d-flex">
            {isBpSiteIdVerified && isSubscriptionActive && (
              <div
                title={getAddressbookLastUpdateTitle(
                  addressBookLastUpdateStatus
                )}
              >
                <Button
                  variant="contained"
                  className={`clinic-button revalidate-bpsiteId ${getAddressbookLastUpdateCss(
                    addressBookLastUpdateStatus
                  )}`}
                  disabled={
                    addressBookLastUpdateStatus?.toUpperCase() === "INPROGRESS"
                  }
                  onClick={() => {
                    revalidateBpSite();
                  }}
                >
                  <span className="px-1">Test Connection</span>
                </Button>
              </div>
            )}
            {auth?.authClaims?.role === Roles.clinicAdmin && (
              <Button
                className="clinic-button manage-subscription"
                id="chargebee-manage-subscription"
                onClick={() => {
                  manageSubscriptionUrl({}).then((res) => {
                    if (res.isSuccess) {
                      (window as any)?.chargebeePortal(res?.data?.data);
                    } else if (res.isError) {
                      if ((res.error as any)?.status !== 401) {
                        setIsCustomerDeleted(true);
                      } else {
                        setErrorMessage(errorMessages.errorInfo);
                      }
                    }
                  });
                }}
              >
                <Settings width={20} height={20} className="pb-1" />
                <span className="px-1">Manage Subscription</span>
              </Button>
            )}
          </div>
        )}
      </div>
      <ConfirmationDialog
        open={isCustomerDeleted}
        contentBody={
          <>
            <div className="text-align-center alert-error-message">Alert!!</div>
            <div className="pt-5">
              <div className="text-align-center">
                Your subscription has expired.
              </div>
              <div className="text-align-center">
                Please contact{" "}
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_SUPPORT_LINK);
                  }}
                >
                  support
                </span>{" "}
                to renew your subscription.
              </div>
            </div>
          </>
        }
        onOk={() => {
          setIsCustomerDeleted(false);
        }}
        okButtonClassName=""
        onCancel={() => {
          setIsCustomerDeleted(false);
        }}
      />
      <ConfirmationDialog
        open={isReverifySuccess}
        contentBody={
          <div className="d-flex flex-column justify-content-center  align-items-center gap-8">
            <DoneIcon />
            <p className="pt-4 dialog-body">BP Site ID verified successfully</p>
          </div>
        }
        onOk={() => {
          setIsReverifySuccess(false);
          window.location.reload();
        }}
        onClose={() => {
          setIsReverifySuccess(false);
          window.location.reload();
        }}
        okButtonName="Ok"
        okButtonClassName="success-ok"
      />
      <ConfirmationDialog
        open={isReverifyFailed}
        contentBody={
          <div className="d-flex flex-column justify-content-center  align-items-center gap-8">
            <InfoIcon />
            <p className="pt-4 dialog-body">
              {errorMessages.cannot_verify_BP_Site_ID}
            </p>
          </div>
        }
        isAlertConfirmation={true}
        onOk={() => {
          setIsReverifyFailed(false);
        }}
        onClose={() => {
          setIsReverifyFailed(false);
        }}
        okButtonName="Ok"
      />
      <ValidatePairingCodeDialog
        open={!isPairedSite}
        bpSiteId={props.clinicUserData?.bpSiteId}
        applicationUserId={userId}
        onSuccess={() => {
          setIsPairedSite(true);
          revalidateBpSite();
        }
        }
        onClose={() => setIsPairedSite(true)}
      />
      <Slider
        isOpen={openBpSiteIdHandler}
        onClose={() => {
          setOpenBpSiteIdHandler(false);
        }}
        title={"Validate BP Site ID"}
      >
        <BpSiteIdVerificationHandler
          onClose={() => {
            setOpenBpSiteIdHandler(false);
            window.location.reload();
          }}
        />
      </Slider>
    </>
  );
}
